// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qk-1";
export var stateContainer = "_qk-0";